import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { Company } from 'src/models';
import { RootState } from 'src/store';
import { companySelectors } from 'src/store/reducers/company';

export const useCompanies = (): Company[] => {
  const companiesState = useSelector<RootState, RootState['companies']>(
    (state) => state.companies,
  );

  const companies = companySelectors.selectAll(companiesState);

  useDebugValue(companies);

  return companies;
};

export const useCompanyById = (companyId: string): Company | null => {
  const companies = useSelector<RootState, RootState['companies']>(
    (state) => state.companies,
  );

  const company = companySelectors.selectById(companies, companyId) || null;

  useDebugValue(company);

  return company;
};
